import { motion } from 'framer-motion';
import { AlertCircle, Target, ArrowRight } from 'lucide-react';

export default function DashboardActionPreview({ actions, navigate }) {
  return (
    <>
      {/* Actions needed */}
      {actions.length > 0 && (
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }} className="mb-4">
          <h3 className="text-[13px] font-medium mb-3" style={{ color: '#3C3226' }}>Action needed</h3>
          {actions.map((action) => (
            <div key={action.text?.slice(0, 40) || action.type} className="p-4 rounded-sm flex items-center gap-3" style={{ backgroundColor: 'rgba(212,68,68,0.04)', border: '1px solid rgba(212,68,68,0.12)' }} data-testid={`action-${action.type || 'item'}`}>
              <AlertCircle size={18} style={{ color: '#D44' }} className="flex-shrink-0" strokeWidth={1.5} />
              <span className="text-[13px]" style={{ color: '#3C3226' }}>{action.text}</span>
            </div>
          ))}
        </motion.div>
      )}

      {/* Action Center CTA */}
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.31 }} className="mb-4">
        <button
          onClick={() => navigate('/actions')}
          className="w-full p-5 rounded-sm flex items-center gap-4 transition-colors hover:bg-[#EDE8DF] text-left group"
          style={{ backgroundColor: '#F7F4EF', border: '1px solid #D4C9B8' }}
          data-testid="action-center-cta"
        >
          <div className="w-12 h-12 rounded-none flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(184,152,90,0.08)' }}>
            <Target size={22} strokeWidth={1.5} style={{ color: '#B8985A' }} />
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-[15px] font-medium block" style={{ color: '#3C3226' }}>Action Center</span>
            <span className="text-[12px]" style={{ color: '#8C7E6E' }}>Your personalized weekly tasks to strengthen how AI mentions you</span>
          </div>
          <ArrowRight size={16} className="flex-shrink-0 text-[#8C7E6E] group-hover:translate-x-0.5 transition-transform" />
        </button>
      </motion.div>
    </>
  );
}
